angular.module('iqxCore')
.controller('ServerStatsCtrl', function ($scope, FormSvc) {
  $scope.checkPermissions('OWNER')
  FormSvc.setOptions($scope,{
      fetchAPI:'stats',
      multiRow:true
      })
    
	$scope.fetch()

  })
